export type DeviceMode = 'auto' | 'mobile' | 'desktop'

export const DEVICE_MODE_STORAGE_KEY = 'habit_device_mode'
export const DESKTOP_BREAKPOINT = 1024

export function getStoredDeviceMode(): DeviceMode {
  if (typeof localStorage === 'undefined') {
    return 'auto'
  }
  try {
    const stored = localStorage.getItem(DEVICE_MODE_STORAGE_KEY)
    if (stored === 'mobile' || stored === 'desktop' || stored === 'auto') {
      return stored
    }
  } catch {
    // Ignore storage read errors
  }
  return 'auto'
}

export function setStoredDeviceMode(mode: DeviceMode): void {
  if (typeof localStorage === 'undefined') {
    return
  }
  try {
    localStorage.setItem(DEVICE_MODE_STORAGE_KEY, mode)
  } catch {
    // Ignore storage write errors
  }
}

export function resolveIsDesktop(
  mode: DeviceMode,
  windowWidth: number,
): boolean {
  if (mode === 'desktop') return true
  if (mode === 'mobile') return false
  return windowWidth >= DESKTOP_BREAKPOINT
}
